import { Form as FinalForm, Field } from 'react-final-form'
import { useTranslation } from 'react-i18next'
import { Grid, Typography } from '@mui/material'
import useDropdown, { Form, validate } from './hooks/useDropdown'
import Button from '../control/Button'
import DropdownInput from '../component/input/DropdownInput'

const DropdownPlayground = () => {
    const { onSubmit, dataList } = useDropdown()
    const { t } = useTranslation()

    const validates = (values: Form) => {
        const validation = validate(values, t) || {}
        return validation
    }

    return (
        <div>
            <Typography variant="h3" gutterBottom>
                Control: Dropdown
            </Typography>
            <FinalForm onSubmit={onSubmit} validate={validates}>
                {({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Field
                                    name={'dropdown1'}
                                    label={'Control (required)'}
                                    placeholder={t('LABEL.SELECT_REQUIRED')}
                                    component={DropdownInput}
                                    options={dataList?.map((item) => ({
                                        value: item.id,
                                        label: item.name,
                                    }))}
                                    required
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Field
                                    name={'dropdown2'}
                                    label={'Control'}
                                    component={DropdownInput}
                                    options={dataList?.map((item) => ({
                                        value: item.id,
                                        label: item.name,
                                    }))}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Field
                                    name={'dropdown3'}
                                    label={'Control (disabled)'}
                                    component={DropdownInput}
                                    options={dataList?.map((item) => ({
                                        value: item.id,
                                        label: item.name,
                                    }))}
                                    disabled
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={1}>
                            <Grid item md={12}>
                                <Button color="primary" onClick={handleSubmit}>
                                    {t('BUTTON.SAVE')}
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                )}
            </FinalForm>
        </div>
    )
}

export default DropdownPlayground
